import { useEffect } from 'react';

const AccessibilityEnhancer = () => {
  useEffect(() => {
    // Add focus indicators to interactive elements
    const style = document.createElement('style');
    style.textContent = `
      /* Enhanced focus indicators */
      .focus-visible:focus-visible,
      button:focus-visible,
      a:focus-visible,
      input:focus-visible,
      textarea:focus-visible,
      select:focus-visible {
        outline: 2px solid hsl(var(--primary)) !important;
        outline-offset: 2px !important;
        border-radius: 4px !important;
      }
      
      /* Remove default focus for mouse users */
      :focus:not(:focus-visible) {
        outline: none !important;
      }
      
      /* Ensure proper contrast for interactive elements */
      button, a, input, textarea, select {
        transition: all 0.2s ease;
      }
      
      /* Skip link for keyboard navigation */
      .skip-link {
        position: absolute;
        top: -40px;
        left: 6px;
        background: hsl(var(--primary));
        color: white;
        padding: 8px;
        text-decoration: none;
        z-index: 100;
        border-radius: 4px;
      }
      
      .skip-link:focus {
        top: 6px;
      }
    `;
    
    document.head.appendChild(style);
    
    // Add skip link for keyboard navigation
    const skipLink = document.createElement('a');
    skipLink.href = '#main-content';
    skipLink.className = 'skip-link';
    skipLink.textContent = 'Przejdź do głównej treści';
    document.body.insertBefore(skipLink, document.body.firstChild);
    
    // Fix third-party injected links without href (e.g., from GTM)
    const fixUncrawlableLinks = () => {
      const linksWithoutHref = document.querySelectorAll('a:not([href])');
      linksWithoutHref.forEach((link) => {
        const text = link.textContent?.trim().toLowerCase();
        // Fix privacy policy links
        if (text?.includes('polityk') || text?.includes('privacy')) {
          link.setAttribute('href', '#privacy-policy');
        }
        // Fix terms links
        if (text?.includes('regulamin') || text?.includes('terms')) {
          link.setAttribute('href', '#terms');
        }
      });
    };
    
    // Run immediately and after DOM changes
    fixUncrawlableLinks();
    const observer = new MutationObserver(fixUncrawlableLinks);
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => {
      document.head.removeChild(style);
      if (skipLink.parentNode) {
        skipLink.parentNode.removeChild(skipLink);
      }
      observer.disconnect();
    };
  }, []);

  return null;
};

export default AccessibilityEnhancer;